import React, { useState } from 'react';
import useDeliveryPickupAxios, { useDeliveryPickupFormData } from '../utils/axios';
import { config } from '@fortawesome/fontawesome-svg-core';
import { useDispatch } from 'react-redux';
import { setAllEmployees } from '../features/employeeSlice';


function useEmployeesApi() {

    const DeliveryPortalAxios = useDeliveryPickupAxios();
    const DeliveryPortalAxios1 = useDeliveryPickupFormData();
    const DeliveryPortalClient = DeliveryPortalAxios;
    DeliveryPortalClient.defaults.timeout = 600000;
    const DeliveryPortalClient1 = DeliveryPortalAxios1;
    DeliveryPortalClient1.defaults.timeout = 600000;

    const [employeeData, setEmployeeData] = useState(null);
    const [employeeRole, setEmployeeRole] = useState(false);
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch();

    const GetEmployees = async () => {
        setLoading(true);
        try {
            const response = await DeliveryPortalAxios.get("/Employee");
            if (response && response.data && response.data.payload) {
                setEmployeeData(response.data.payload)
                dispatch(setAllEmployees(response.data.payload.employees))
            }
        } catch (error) {   
            console.error("Error fetching orders:", error);
        } finally {
            setLoading(false);  
        }
    }

    const GetEmployeesRoles = async () => {
        try {
            const response = await DeliveryPortalAxios.get("/Employee/Roles");
            if (response && response.data && response.data.payload) {
                setEmployeeRole(response.data.payload)
            }
        } catch (error) {
            console.error("Error fetching roles", error);
        }
    }

    const AddEmployee = async (payload) => {
          const response = await DeliveryPortalAxios.post("/Employee/Add", payload)
            
          return response.data.payload;
    }

    const ChangeStatusEmployee = async (payload) => {
        const response = await DeliveryPortalAxios.post("/Employee/ChangeStatus", payload)
          
        return response;
    }
  

    const DeleteEmployee = async (payload) => {
        const response = await DeliveryPortalAxios.post("/Employee/Delete", payload);
      
        return response;
    }


    const EditEmployee = async (payload) => {
        const response = await DeliveryPortalAxios.post("/Employee/Edit", payload)
          
        return response;
    }


    return {
        GetEmployees,
        loading,
        employeeData,
        GetEmployeesRoles,
        employeeRole,
        AddEmployee,
        ChangeStatusEmployee,
        DeleteEmployee,
        EditEmployee
    }
}

export default useEmployeesApi;